import React from 'react'
import List from './List'
import { useCandidateResumeReviewById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const candidate = useCandidateResumeReviewById(id)
  return (
    <List candidate={candidate} />
  )
}

export default Body
